import { PaginationResult } from "../../../../lib/definitions";
import { User } from "../../../../models";
import UserService from "../../../../services/UserService";
 
const ITEMS_PER_PAGE = 6;
const userService = new UserService();
export async function fetchUsersPages(page: number =1, pageSize: number=10, query: string=''): Promise<PaginationResult<User>> {
  try {
    return await userService.getUsers(page, pageSize, query)
} catch (error) {
    console.error("Database Error:", error);
    throw new Error("Failed to fetch users.");
  }
}
// }
// export const getUserRole = (role: string): UserRole | undefined => {
//   switch (role.toUpperCase().replace(' ', '')) {
//     case 'ADMIN':
//       return UserRole.ADMIN;
//     case 'USER':
//       return UserRole.USER;
//     case 'SUPERADMIN':
//       return UserRole.SUPERADMIN;
//     default:
//       return undefined;
//   }
// }
// export const getUserStatus = (status: string): UserStatus | undefined => {
//   switch (status.toUpperCase()) {
//     case 'ACTIVE':
//       return UserStatus.ACTIVE;
//     case 'PENDING':
//       return UserStatus.PENDING;
//     case 'SUSPENDED':
//       return UserStatus.SUSPENDED;
//     default:
//       return undefined;
//   }
// }
// export async function fetchFilteredUsers(
//   query: string,
//   currentPage: number,
// ) {
//   const offset = (currentPage - 1) * ITEMS_PER_PAGE;

//   try {
//   // Using Prisma to fetch users with pagination and filtering
  
//     if (currentPage < 1) {
//       throw new Error("Current page must be greater than or equal to 1.");
//     }
//     if (offset < 0) {
//       throw new Error("Offset must be greater than or equal to 0.");
//     }
//     if (ITEMS_PER_PAGE < 1) {
//       throw new Error("Items per page must be greater than or equal to 1.");
//     }
//     if (currentPage > 1000) {
//       throw new Error("Current page must be less than or equal to 1000.");
//     }
//     const users = await prisma.user.findMany({
//       where: {
//         OR: [
//           { name: { contains: query} },
//           { email: { contains: query} },
//           { role: { equals: getUserRole(query) } },
//           { status: { equals: getUserStatus(query) } },
//           {emailVerified: query === 'verified' ? true : query === 'not verified' ? false : undefined}
//         ],
//       },
//       orderBy: {
//         name: 'asc',
//       },
//       take: ITEMS_PER_PAGE,
//       skip: offset,
//     });
//     if (!users || users.length === 0) {
//       return [];
//     }  
//     return users;
//   } catch (error) {
//     console.error('Database Error:', error);
//     throw new Error('Failed to fetch users.');
//   }
// }
export async function fetchUserById(id: string): Promise<User | null> {
  try {
    const user = await userService.getUserById(id);
    return user;
  } catch (error) {
    console.error('Database Error:', error);
    throw new Error('Failed to fetch user by ID.');
  }
}